import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClientModule } from '@angular/common/http';
import { OverlayModule } from '@angular/cdk/overlay';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IntroductionComponent } from './introduction/introduction.component';
import { Deactivate1Component } from './deactivate1/deactivate1.component';
import { FaqComponent } from './faq/faq.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';

import { CommonModule } from '@angular/common';

// import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { LocationStrategy, HashLocationStrategy, PathLocationStrategy } from '@angular/common';

import { LoginComponent } from './login/login.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { GetdataComponent } from './getdata/getdata.component';
import { FailmodalComponent } from './failmodal/failmodal.component';
import { DialogboxComponent } from './dialogbox/dialogbox.component';
import { MatDatepickerModule, MatNativeDateModule, MatAutocompleteModule, MatBadgeModule, MatBottomSheetModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatStepperModule, MatDividerModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatTreeModule } from '@angular/material';
import { A11yModule } from '@angular/cdk/a11y';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule, CdkColumnDef } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { DownloadComponent } from './download/download.component';
import { QRCodeModule } from 'angular2-qrcode';
import { DefaultLayoutComponent } from './default-layout/default-layout.component';
import { NewAppComponent } from './new-app/new-app.component';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { KycdisplayComponent } from './kycdisplay/kycdisplay.component';

// import { FlexLayoutModule } from '@angular/flex-layout';

// import { InputRestrictionDirective } from './_validators/noSpace'

@NgModule({
  declarations: [
    AppComponent,
    IntroductionComponent,
    Deactivate1Component,
    FaqComponent,
    LoginComponent,
    FeedbackComponent,
    GetdataComponent,
    FailmodalComponent,
    DialogboxComponent,
    DownloadComponent,
    DefaultLayoutComponent,
    NewAppComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent,
    KycdisplayComponent,    
    // InputRestrictionDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    CommonModule,
    // NgbModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    BrowserAnimationsModule,
    MatButtonModule,
    OverlayModule,
    MatDatepickerModule,
    MatNativeDateModule,
    A11yModule,

    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,

    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    PortalModule,
    ScrollingModule,
    RecaptchaModule,  //this is the recaptcha main module
    RecaptchaFormsModule, //this is the module for form incase form validation
    QRCodeModule,
    // FlexLayoutModule,
    Ng2TelInputModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
    ],
    entryComponents:[DialogboxComponent,FailmodalComponent, LoginComponent],
  providers: [CdkColumnDef,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: MAT_DIALOG_DATA, useValue: [] },
    { provide: MatDialogRef, useValue: [] }
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
